export const userNameProvider = {
  values: [
    {
      provider: 'id:root',
      property: 'headerText',
    },
    {
      provider: 'GlobalStoreProviderService',
      property: {
        paths: 'user.current',
      },
      transform: function (user: { displayName: string }) {
        return user.displayName?.split(' ')[0];
      }.toString(),
    },
    {
      provider: 'id:root',
      property: 'showUserNameInPanelTitle',
    },
  ],
  transform: function ([headerTextArg, firstName, showUserNameInPanelTitle]: [
    string,
    string,
    boolean,
  ]) {
    if (showUserNameInPanelTitle) {
      return `${headerTextArg}, ${firstName}`;
    }
    return headerTextArg;
  }.toString(),
};
